import {
  getConversationStreamApi,
  sendMessageApi,
  sendImageApi,
  sendInternalMessageApi,
  sendMessageCardApi,
  endConversationApi,
  redirectConversationApi,
  redirectConversationByGroupApi,
  handleSummaryConversationApi,
  handleInternalRemindApi,
  fetchUploadPoliciesApi,
  sendFileApi,
  toTranslation,
  inviteEvaluationApi,
  handleSuggestionApi,
  withdrawMessageApi,
  redirectConversationToAI
} from '../api';
import { removeConvStatusApi, getConvStatusApi, getConversationApi } from '../api/conversation';
import { ENV_CONFIG } from '@laigu/constants';

const eventOn = emitter => {
  emitter.promiseOn('getConversationStream', payload => {
    return getConversationStreamApi(payload);
  });

  emitter.promiseOn('sendMessage', payload => {
    return sendMessageApi(payload);
  });

  emitter.promiseOn('sendInternalMessage', payload => {
    return sendInternalMessageApi(payload);
  });

  emitter.promiseOn('uploadImage', payload => {
    return sendImageApi(payload);
  });

  emitter.promiseOn('sendMessageCard', payload => {
    return sendMessageCardApi(payload);
  });

  emitter.promiseOn('handleEndConversation', payload => {
    return endConversationApi(payload);
  });

  emitter.promiseOn('handleRedirectConversation', payload => {
    return redirectConversationApi(payload);
  });

  emitter.promiseOn('handleRedirectConversationByGroup', payload => {
    return redirectConversationByGroupApi(payload);
  });

  emitter.promiseOn('handleRedirectConversationToAI', payload => {
    return redirectConversationToAI(payload);
  });

  emitter.promiseOn('handleSummaryConversation', payload => {
    return handleSummaryConversationApi(payload);
  });

  emitter.promiseOn('handleInternalRemind', payload => {
    return handleInternalRemindApi(payload);
  });

  emitter.promiseOn('uploadFile', async payload => {
    const { file, onUploadProgress } = payload;
    const { policy = {} } = await fetchUploadPoliciesApi({ filename: file.name, content_type: 'file' });
    const { fields, url } = policy;
    const { key } = fields;
    try {
      const sendFileResp = await sendFileApi({ fields, file, url, onUploadProgress });
      return { success: true, url: sendFileResp?.key || key };
    } catch (e) {
      return { success: false };
    }
  });

  emitter.promiseOn('uploadVideo', async payload => {
    const { file, onUploadProgress } = payload;
    const { policy = {}, file_url } = await fetchUploadPoliciesApi({ filename: file.name, content_type: 'video' });
    const { fields, url } = policy;
    const { key } = fields;
    try {
      const sendFileResp = await sendFileApi({ fields, file, url, onUploadProgress });
      return { success: true, url: sendFileResp?.key || key, file_url: sendFileResp?.url || file_url };
    } catch (e) {
      return { success: false };
    }
  });

  emitter.promiseOn('inviteEvaluation', payload => {
    return inviteEvaluationApi(payload);
  });

  emitter.promiseOn('handleSuggestion', payload => {
    return handleSuggestionApi(payload);
  });

  emitter.promiseOn('getConvStatus', payload => {
    return getConvStatusApi(payload);
  });

  emitter.promiseOn('removeConvStatus', payload => {
    return removeConvStatusApi(payload);
  });

  emitter.promiseOn('withdrawMessage', payload => {
    const { msgId, is_truested } = payload;
    return withdrawMessageApi(msgId, is_truested);
  });

  emitter.promiseOn('getConversation', payload => {
    return getConversationApi(payload);
  });

  emitter.promiseOn('translate', payload => toTranslation(payload));
};

export default eventOn;
